import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 315px;
  padding-bottom: 80px;
  margin-bottom: 80px;
  width: 100%;
`;
